import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { isGlobalAdminRole } from "../utils/isGlobalAdmin";

/**
 * Restricts routes to global ADMIN / SUPER_ADMIN (auth.user.role).
 */
function AdminRoute({ children }) {
	const role = useSelector((state) => state.auth?.user?.role);
	if (!isGlobalAdminRole(role)) {
		return <Navigate to="/projects" replace />;
	}
	return children;
}

export default AdminRoute;
